/**
 * Workspace Utilities
 * 
 * Pure utility functions for workspace operations.
 * NO dependencies on React contexts/hooks to avoid circular dependencies.
 */

import { WorkspaceInfo } from '@/contexts/WorkspaceScope.context';

/**
 * Get accessible workspace IDs from workspace list
 */
export function getAccessibleWorkspaceIds(workspaces: WorkspaceInfo[]): string[] {
  if (!workspaces || workspaces.length === 0) {
    return [];
  }
  return workspaces.map(w => w.workspace_id);
}

/**
 * Check if workspace is accessible
 */
export function isWorkspaceAccessible(workspaceId: string, workspaces: WorkspaceInfo[]): boolean {
  return workspaces.some(w => w.workspace_id === workspaceId);
}
